'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import { TopNavV5SubMenuTileSlider } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5SubMenuTileSlider';
import type { LinkItemWithStamp, TopNavV5SubMenuItem } from '@src/components/TopNavV5/TopNavV5Props';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavV5MobileSubMenu = () => {
  const $ = _c(42);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    mobileState,
    mobileDispatch
  } = useTopNavV5();
  const miniMenu = mobileState.miniMenu;
  const subMenu = mobileState.state === "left-menu-sub-menu-open" ? mobileState.leftMenu?.items[mobileState.leftMenuIndex ?? 0] : mobileState.subMenu;
  const hasMiniMenu = Boolean(miniMenu) && mobileState.state !== "left-menu-sub-menu-open";
  let t0;
  if ($[0] !== hasMiniMenu || $[1] !== miniMenu?.title || $[2] !== mobileDispatch || $[3] !== mobileState.state || $[4] !== subMenu?.title) {
    t0 = () => {
      const title = hasMiniMenu ? miniMenu?.title : subMenu?.title;
      return <div className="flex h-14 items-center border-b border-white/10 p-4"><button onClick={() => {
          if (mobileState.state === "left-menu-sub-menu-open") {
            mobileDispatch({
              type: "BACK_FROM_LEFT_MENU_SUB_MENU"
            });
          } else {
            mobileDispatch({
              type: "BACK_FROM_SUB_MENU"
            });
          }
        }} className="flex items-center gap-2"><ChevronLeftIcon className="size-5 text-bodi-accent-bright-500" /><p className="text-heading-4 text-left font-lateral">{title}</p></button></div>;
    };
    $[0] = hasMiniMenu;
    $[1] = miniMenu?.title;
    $[2] = mobileDispatch;
    $[3] = mobileState.state;
    $[4] = subMenu?.title;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const renderTitle = t0;
  let t1;
  if ($[6] !== hasMiniMenu || $[7] !== mobileDispatch || $[8] !== subMenu?.ctaMobile?.href || $[9] !== subMenu?.ctaMobile?.newTab || $[10] !== subMenu?.ctaMobile?.title || $[11] !== subMenu?.hasCtaMobile || $[12] !== trackSelectNavCta) {
    t1 = () => {
      if (hasMiniMenu) {
        return null;
      }
      const content = <Button className="w-full" size="medium">{subMenu?.ctaMobile?.title}</Button>;
      return subMenu?.hasCtaMobile && subMenu?.ctaMobile?.title && <><div className="h-[170px]" /><div className="fixed bottom-0 left-0 h-[85px] w-screen border-t border-bodi-gray-dark bg-bodi-black-text px-4 py-5"><div className="font-medium text-bodi-accent-bright-500">{subMenu?.ctaMobile?.href ? <LocalizedLink data-testid="menu-featured-item-mobile" onClick={() => {
              trackSelectNavCta({
                "cta url": subMenu?.ctaMobile?.href
              });
              mobileDispatch({
                type: "CLOSE_FROM_SUB_MENU"
              });
            }} href={subMenu?.ctaMobile?.href ?? ""} rel={subMenu?.ctaMobile?.newTab ? "noopener noreferrer" : ""} target={subMenu?.ctaMobile?.newTab ? "_blank" : "_self"}>{content}</LocalizedLink> : <div>{content}</div>}</div></div></>;
    };
    $[6] = hasMiniMenu;
    $[7] = mobileDispatch;
    $[8] = subMenu?.ctaMobile?.href;
    $[9] = subMenu?.ctaMobile?.newTab;
    $[10] = subMenu?.ctaMobile?.title;
    $[11] = subMenu?.hasCtaMobile;
    $[12] = trackSelectNavCta;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  const renderCtaMobile = t1;
  let t2;
  if ($[14] !== mobileDispatch || $[15] !== trackSelectNavCta) {
    t2 = (item, itemIdx) => <div key={`${item.title}-${itemIdx}`} className={cn("border-t border-white/10 px-4 py-6", {
      "border-t-0": itemIdx === 0
    })}><div className="mb-2 text-body-md font-medium">{item.isLink ? <LocalizedLink className="inline-block hover:underline" data-testid={`sub-menu-${itemIdx}`} onClick={() => {
          trackSelectNavCta({
            "cta url": item?.link?.href ?? ""
          });
          mobileDispatch({
            type: "CLOSE_FROM_SUB_MENU"
          });
        }} href={item?.link?.href ?? ""} key={`${item.title}-${itemIdx}`} rel={item?.link?.newTab ? "noopener noreferrer" : ""} target={item?.link?.newTab ? "_blank" : "_self"}>{item.title}</LocalizedLink> : <div>{item.title}</div>}</div><div className="flex flex-col gap-3">{item.links?.filter(_temp).map((subItem_0, subItemIdx) => <LocalizedLink className="flex w-fit items-center gap-1 text-body-sm font-medium text-bodi-gray-butters hover:underline" data-testid={`sub-menu-${subItemIdx}`} onClick={() => {
          trackSelectNavCta({
            "cta url": subItem_0?.href
          });
          mobileDispatch({
            type: "CLOSE_FROM_SUB_MENU"
          });
        }} href={subItem_0?.href ?? ""} key={`${subItem_0.title}-${subItemIdx}`} rel={subItem_0?.newTab ? "noopener noreferrer" : ""} target={subItem_0?.newTab ? "_blank" : "_self"}><div>{subItem_0.title}</div>{subItem_0.stamp && <>{"-"}<span className="text-body-sm font-medium text-bodi-accent-bright-500">{subItem_0.stamp}</span></>}</LocalizedLink>)}</div></div>;
    $[14] = mobileDispatch;
    $[15] = trackSelectNavCta;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const renderSubItem = t2;
  let t3;
  if ($[17] !== mobileDispatch || $[18] !== trackSelectNavCta) {
    t3 = (item_0, itemIdx_0) => <LocalizedLink className="text-body-sm font-medium text-bodi-gray-butters hover:underline" data-testid={`sub-menu-${itemIdx_0}`} onClick={() => {
      trackSelectNavCta({
        "cta url": item_0?.href
      });
      mobileDispatch({
        type: "CLOSE_FROM_SUB_MENU"
      });
    }} href={item_0?.href ?? ""} key={`${item_0.title}-${itemIdx_0}`} rel={item_0?.newTab ? "noopener noreferrer" : ""} target={item_0?.newTab ? "_blank" : "_self"} dangerouslySetInnerHTML={{
      __html: item_0.title ?? ""
    }} />;
    $[17] = mobileDispatch;
    $[18] = trackSelectNavCta;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const renderMiniMenuSubItem = t3;
  let t4;
  if ($[20] !== renderTitle) {
    t4 = renderTitle();
    $[20] = renderTitle;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== hasMiniMenu || $[23] !== renderSubItem || $[24] !== subMenu?.items) {
    t5 = !hasMiniMenu && subMenu?.items?.filter(_temp2).map(renderSubItem);
    $[22] = hasMiniMenu;
    $[23] = renderSubItem;
    $[24] = subMenu?.items;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== hasMiniMenu || $[27] !== miniMenu?.items || $[28] !== renderMiniMenuSubItem) {
    t6 = hasMiniMenu && <div className="flex flex-col gap-3 px-4 py-6">{miniMenu?.items?.filter(_temp3).map(renderMiniMenuSubItem)}</div>;
    $[26] = hasMiniMenu;
    $[27] = miniMenu?.items;
    $[28] = renderMiniMenuSubItem;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== hasMiniMenu) {
    t7 = !hasMiniMenu && <TopNavV5SubMenuTileSlider />;
    $[30] = hasMiniMenu;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t5 || $[33] !== t6 || $[34] !== t7) {
    t8 = <div className="relative flex flex-col">{t5}{t6}{t7}</div>;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== renderCtaMobile) {
    t9 = renderCtaMobile();
    $[36] = renderCtaMobile;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== t4 || $[39] !== t8 || $[40] !== t9) {
    t10 = <div className="relative">{t4}{t8}{t9}</div>;
    $[38] = t4;
    $[39] = t8;
    $[40] = t9;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  return t10;
};
function _temp(subItem) {
  return Boolean(subItem.title);
}
function _temp2(item_1) {
  return Boolean(item_1.title);
}
function _temp3(item_2) {
  return Boolean(item_2.title);
}